// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const APP_VERSION = {
    version: '6.0.3',
    tag: 'v-pace-pwa-6.0.3',
    commitHash: 'b145c3f87',
    branchName: 'release/pace-pwa-6.0.3',
    timestamp: '2026-10-22T14:35:57.364Z',
};
